import { Trash2 } from "lucide-react";
import { PaymentCard } from "@/features/payment/types";
import { CardView } from "@/features/payment/components/CardView";
import { ActionMenu } from "@/components/ui/ActionMenu";
import useDisclosure from "@/hooks/useDsiclosure";
import DeletePatientCardConfirmation from "../DeletePatientCardConfirmation";

interface CardOnFileRowProps {
  card: PaymentCard;
  patientFullName: string;
  patientId: string;
  practiceId: string;
}

export function CardOnFileRow({
  card,
  patientId,
  practiceId,
  patientFullName,
}: CardOnFileRowProps) {
  const deleteCardDisclosure = useDisclosure();

  return (
    <div className="rounded-card mb-4 flex items-center gap-3.5 border bg-white px-5 py-4 shadow-[0_1px_3px_rgba(0,0,0,0.04)]">
      <CardView card={card} fallbackName={patientFullName} />

      <ActionMenu
        triggerLabel={`Open card actions for ${patientFullName}`}
        testId="card-actions-menu"
        items={[
          {
            label: "Delete Card",
            icon: Trash2,
            variant: "destructive",
            onClick: deleteCardDisclosure.onOpen,
            testId: "delete-card-action",
          },
        ]}
      />
      <DeletePatientCardConfirmation
        cardOnFile={card}
        patientId={patientId}
        practiceId={practiceId}
        patientFullName={patientFullName}
        open={deleteCardDisclosure.open}
        onClose={deleteCardDisclosure.onClose}
      />
    </div>
  );
}
